module.exports = __webpack_public_path__ + "static/media/image20.350eade9.JPG";